import { render, staticRenderFns } from "./JudgeNode.vue?vue&type=template&id=3bcfe06a&scoped=true&"
import script from "./JudgeNode.vue?vue&type=script&lang=js&"
export * from "./JudgeNode.vue?vue&type=script&lang=js&"
import style0 from "./JudgeNode.vue?vue&type=style&index=0&id=3bcfe06a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcfe06a",
  null
  
)

export default component.exports